
export const FILESYSTEM_NAME = "filesystemName";
export const CREATION_DATE = "creationDate";
export const LAST_EDITED_DATE = "lastEditedDate";
export const CREATOR_ID = "creatorId";
export const PERMISSIONS = "permissions";

